import { render, staticRenderFns } from "./gongshang.vue?vue&type=template&id=23bdd3b1&scoped=true"
import script from "./gongshang.vue?vue&type=script&lang=js"
export * from "./gongshang.vue?vue&type=script&lang=js"
import style0 from "./gongshang.vue?vue&type=style&index=0&id=23bdd3b1&prod&scoped=true&lang=less"
import style1 from "./gongshang.vue?vue&type=style&index=1&id=23bdd3b1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bdd3b1",
  null
  
)

export default component.exports